// The AccountsApi the shared login UI uses. A lazy singleton over the real HTTP client (@wiser/accounts),
// with an injection seam so dev/tests can swap in the in-memory MockAccounts (or point at a local service).
// Each host app configures the real URL at startup from its own env (e.g. VITE_WISER_ACCOUNTS_URL).
import { AccountsClient, type AccountsApi } from '@wiser/accounts';

let api: AccountsApi | undefined;
let baseUrl = '/api/wiser-accounts'; // default; the host should configure the real URL at startup

/** Configure the accounts backend: a base URL (real service) or a ready AccountsApi (tests / mock). */
export function configureAccountsApi(opts: { baseUrl?: string; api?: AccountsApi }): void {
  if (opts.api) { api = opts.api; return; }
  // '' is a VALID value (same-origin — what the hosted login SPA passes), so
  // only "not provided" keeps the default. `if (opts.baseUrl)` swallowed '' and
  // left the hosted page on /api/wiser-accounts → every sign-in 404'd (found by
  // the wiser-tester login marathon, 2026-07-18).
  if (opts.baseUrl !== undefined) baseUrl = opts.baseUrl;
  api = undefined; // recreate lazily against the new URL
}

export function getAccountsApi(): AccountsApi {
  if (!api) api = new AccountsClient({ baseUrl });
  return api;
}

/** The configured wiser-accounts base URL — so sibling features (e.g. account-synced prefs) hit the SAME
 *  service the AccountsApi uses, without re-plumbing discovery. */
export function getAccountsBaseUrl(): string {
  return baseUrl;
}
